import { CSSProperties } from "react";
import { AnserJsonEntry, ansiToJson } from "anser";

export const decodeThemedLogsAnsi = (value: string) =>
  ansiToJson(value, {
    json: true,
    use_classes: true,
    remove_empty: true,
  });

export const getLogLineStyles = (entry: AnserJsonEntry) => {
  const style: CSSProperties = {};

  if (entry.decorations.includes("bold")) {
    style.fontWeight = 800;
  }

  if (entry.decorations.includes("dim")) {
    style.opacity = "70%";
  }

  if (entry.decorations.includes("underline")) {
    style.textDecoration = "underline";
  }

  return style;
};

export const transformAnsiToLines = (decoded: AnserJsonEntry[]): AnserJsonEntry[][] => {
  const lines: AnserJsonEntry[][] = [];
  let currentLine: AnserJsonEntry[] = [];

  decoded.forEach((entry) => {
    if (entry.content.includes("\n")) {
      const parts = entry.content.split(/(\n)/);
      parts.forEach((part) => {
        if (part === "\n") {
          currentLine.push({ ...entry, content: part });
          lines.push(currentLine);
          currentLine = [];
        } else {
          currentLine.push({ ...entry, content: part });
        }
      });
    } else {
      currentLine.push(entry);
    }
  });

  if (currentLine.length > 0) {
    lines.push(currentLine);
  }

  return lines;
};

export const findSearchOccurrences = (
  transformedCode: AnserJsonEntry[][],
  searchPhrase: string
): { lineIndex: number; occurrenceIndex: number }[] => {
  if (!searchPhrase.trim()) {
    return [];
  }

  const search = searchPhrase.toLowerCase();
  const occurrences: { lineIndex: number; occurrenceIndex: number }[] = [];

  transformedCode.forEach((line, lineIndex) => {
    const lineText = line
      .map((entry) => entry.content)
      .join("")
      .toLowerCase();

    let currentIndex = 0;
    let occurrenceIndex = 0;
    
    while (currentIndex < lineText.length) {
      const foundIndex = lineText.indexOf(search, currentIndex);
      if (foundIndex === -1) break;
      
      occurrences.push({ lineIndex, occurrenceIndex });
      occurrenceIndex++;
      currentIndex = foundIndex + 1;
    }
  });

  return occurrences;
};
